import { SET_USER_ROUTER, ASYNC_ROUTER_MARK, SET_TABLEDATA } from "./actionTypes";
import { IState } from "@/typings";
export default {
  [SET_USER_ROUTER](state: IState, data: []) {
    state.routerArr = data;
  },
  [ASYNC_ROUTER_MARK](state: IState, data: boolean) {
    state.routerState = data;
  },
  [SET_TABLEDATA](state: IState, data: []) {
    state.submitTableData = data;
  },
};
